module.exports = __webpack_public_path__ + "static/media/opensans-semibolditalic-webfont.a6357716.woff";


//////////////////
// WEBPACK FOOTER
// ./src/static/fonts/opensans-semibolditalic-webfont.woff
// module id = 1010
// module chunks = 0